var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { createSelector } from 'reselect';
import { GET_CONTACTS_SUCCESS, GET_COLUMNS_SUCCESS, GET_EVENTS, GET_EVENTS_SUCCESS, HIDE_EVENTS, UPDATE_COLUMNS, SET_DATE_RANGE, CLEAR_FILTER, SET_FILTER_TAGS, ADD_TAG, REMOVE_TAG, GET_FILTER_ITEMS_SUCCESS, SET_FILTER_ITEMS_OPENED, SET_FILTERING_BY_ITEM, UPDATE_EDITED_FILTERS_LIST, UPDATE_TEMP_PAGE_WITH_ITEMS, OPEN_TOOLTIP_TAG_GROUP, CLOSE_TOOLTIP_TAG_GROUP, CLEAR_TOOLTIP_TAG_GROUP, SAVE_CALL_RANGE_FILTER_FORM, UPDATE_TEMP_EDITED_FILTERS_LIST, CLEAR_EDITED_FILTERS_LIST, REVERT_EDITED_FILTER_CHANGES, TAKE_EDITING_FILTER_SNAPSHOT, UPDATE_TEMP_FILTER_MAXDATA, RESET_STATE, UPDATE_TEMP_TAG, UPDATE_EXPANDED_LIST, SET_CALL_FINISH_TYPE_FILTER, REMOVE_CALL_FINISH_TYPE_FILTER, TAKE_CALL_FINISH_TYPE_SNAPSHOT, REVERT_CALL_FINISH_TYPE_SNAPSHOT, TOGGLE_CONTACTS_TABLE, GET_RAW_COLUMNS_SUCCESS, EDIT_SEARCH_PHRASE_ACTION, SET_MASSIVE_OPTION_ACTION, TOGGLE_TAG_EDITOR_ACTION, CLEAR_PAGE_OFFSET_ACTION, SET_PAGE_OFFSET_ACTION } from './../contacts/contacts.actions';
import * as moment from 'moment';
export var initialState = {
    eventsOption: false,
    massiveActions: false,
    excludedContacts: [],
    items: {
        total: 1,
        data: [
            {
                events_count: 0,
                NATIVE_CLIENT_PHONE_NUMBER: [
                    {
                        blank: false,
                        eea: false,
                        id: null,
                        initial: false,
                        isoCountry: 'pl',
                        label: '+MOCKNUMBER',
                        msisdn: '+MOCKNUMBER',
                        notBlank: true,
                        optionalIsoCountry: { present: true },
                        present: true,
                        source: null
                    }
                ],
                NATIVE_EVENT_DATE: '2019-02-12T11:24:55.959Z',
                NATIVE_SURNAME: null,
                NATIVE_EVENT_TYPE: 'ImportContactEvent',
                NATIVE_CREATOR_LOGIN: 'lukasz.barbuzinski@crazycall.com',
                NATIVE_AGENT_PHONE_NUMBER: null,
                NATIVE_EVENT_STATUS_INFO: null,
                NATIVE_EMAIL: null,
                NATIVE_NAME: null,
                NATIVE_COMPANY: null,
                NATIVE_RECORD_ID: 80,
                NATIVE_CALL_LENGTH: null,
                info: 'dodatkowe_info',
                NATIVE_TAGS: ['tag111', 'tag222']
            }
        ]
    },
    columns: [
        { type: 'NATIVE', key: 'RECORD_ID', name: 'iRecord Name', frozenLeft: false, translation: 'TiRecord Name' },
        { type: 'NATIVE', key: 'EVENT_DATE', name: 'iEvent Date', frozenLeft: false, translation: 'TiEvent Date' },
        { type: 'NATIVE', key: 'EVENT_TYPE', name: 'iEvent Type', frozenLeft: false, translation: 'TiEvent Type' },
        { type: 'NATIVE', key: 'CREATOR_LOGIN', name: 'iCreator Login', frozenLeft: false, translation: 'TiCreator Login' },
        {
            type: 'NATIVE',
            key: 'CLIENT_PHONE_NUMBER',
            name: 'iClient Phone Number',
            frozenLeft: true,
            translation: 'TiClient Phone Number'
        },
        {
            type: 'NATIVE',
            key: 'AGENT_PHONE_NUMBER',
            name: 'iAgent Phone Number',
            frozenLeft: false,
            translation: 'TiAgent Phone Number'
        },
        {
            type: 'NATIVE',
            key: 'EVENT_STATUS_INFO',
            name: 'iEvent Status Info',
            frozenLeft: false,
            translation: 'TiEvent Status Info'
        },
        { type: 'NATIVE', key: 'CALL_LENGTH', name: 'iCall Length', frozenLeft: false, translation: 'TiCall Length' },
        { type: 'NATIVE', key: 'NAME', name: 'iName', frozenLeft: false, translation: 'TiName' },
        { type: 'NATIVE', key: 'SURNAME', name: 'iSurname', frozenLeft: false, translation: 'TiSurname' },
        { type: 'NATIVE', key: 'COMPANY', name: 'iCompany', frozenLeft: false, translation: 'TiCompany' },
        { type: 'NATIVE', key: 'EMAIL', name: 'iEmail', frozenLeft: false, translation: 'TiEmail' },
        { type: 'NATIVE', key: 'hurtownia', name: 'iHurtownia', frozenLeft: false, translation: 'iHurtownia' },
        { type: 'NATIVE', key: 'TAGS', name: 'Tags', frozenLeft: false, translation: 'Tags' },
        { type: 'NATIVE', key: 'info', name: 'iInfo', frozenLeft: false, translation: 'iInfo' }
    ],
    rawColumns: [
        { type: 'NATIVE', key: 'RECORD_ID', name: 'iRecord Name', frozenLeft: false, translation: 'TiRecord Name' },
        { type: 'NATIVE', key: 'EVENT_DATE', name: 'iEvent Date', frozenLeft: false, translation: 'TiEvent Date' },
        { type: 'NATIVE', key: 'EVENT_TYPE', name: 'iEvent Type', frozenLeft: false, translation: 'TiEvent Type' },
        { type: 'NATIVE', key: 'CREATOR_LOGIN', name: 'iCreator Login', frozenLeft: false, translation: 'TiCreator Login' },
        {
            type: 'NATIVE',
            key: 'CLIENT_PHONE_NUMBER',
            name: 'iClient Phone Number',
            frozenLeft: true,
            translation: 'TiClient Phone Number'
        },
        {
            type: 'NATIVE',
            key: 'AGENT_PHONE_NUMBER',
            name: 'iAgent Phone Number',
            frozenLeft: false,
            translation: 'TiAgent Phone Number'
        },
        {
            type: 'NATIVE',
            key: 'EVENT_STATUS_INFO',
            name: 'iEvent Status Info',
            frozenLeft: false,
            translation: 'TiEvent Status Info'
        },
        { type: 'NATIVE', key: 'CALL_LENGTH', name: 'iCall Length', frozenLeft: false, translation: 'TiCall Length' },
        { type: 'NATIVE', key: 'NAME', name: 'iName', frozenLeft: false, translation: 'TiName' },
        { type: 'NATIVE', key: 'SURNAME', name: 'iSurname', frozenLeft: false, translation: 'TiSurname' },
        { type: 'NATIVE', key: 'COMPANY', name: 'iCompany', frozenLeft: false, translation: 'TiCompany' },
        { type: 'NATIVE', key: 'EMAIL', name: 'iEmail', frozenLeft: false, translation: 'TiEmail' },
        { type: 'NATIVE', key: 'hurtownia', name: 'iHurtownia', frozenLeft: false, translation: 'iHurtownia' },
        { type: 'NATIVE', key: 'TAGS', name: 'Tags', frozenLeft: false, translation: 'Tags' },
        { type: 'NATIVE', key: 'info', name: 'iInfo', frozenLeft: false, translation: 'iInfo' }
    ],
    expandedId: null,
    expandedList: [],
    page: {
        pagination: {
            limit: 10,
            offset: 0,
            size: 0,
            totalElements: 0,
            sortBy: null,
            order: null
        },
        filter: {
            dateFrom: moment()
                .subtract(7, 'day')
                .toISOString(),
            dateTo: moment().endOf('day').add(moment().utcOffset() / 60, 'hours'),
            contactId: null
        }
    },
    filterTags: {},
    tempFilterTags: {},
    editedFilters: [],
    tempEditedFilters: [],
    openedTagGroupTooltips: [],
    editingFilterSnapshot: undefined,
    openedFilter: undefined
};
export function contactsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    var _a, _b, _c, _d, _e, _f;
    if (!state.page) {
        state = initialState;
    }
    switch (action.type) {
        case GET_COLUMNS_SUCCESS:
            return __assign({}, state, { columns: action.payload.dataCol });
        case GET_RAW_COLUMNS_SUCCESS:
            return __assign({}, state, { rawColumns: action.payload });
        case GET_CONTACTS_SUCCESS:
            var snapshotUpdated = {
                tempFilterTags: __assign({}, state.filterTags),
                editedFiltersItems: __assign({}, state.editedFiltersItems),
                tempPage: action.payload.page,
                openedFilter: null,
                tempEditedFilters: state.editedFilters.slice(),
                editedFilters: state.editedFilters.slice(),
                massiveActions: state.massiveActions
            };
            return __assign({}, state, { items: action.payload.data.items, page: action.payload.page, tempPage: action.payload.page, editingFilterSnapshot: snapshotUpdated, massiveActions: state.massiveActions });
        case GET_EVENTS:
            return __assign({}, state, { expandedId: action.payload.filter.contactId });
        case GET_EVENTS_SUCCESS:
            var contact = state.items.data.find(function (row) { return row.NATIVE_RECORD_ID === state.expandedId; });
            var updatedContact_1 = __assign({}, contact, { events: action.payload.items.data, expanded: true });
            var rowsUpdated = state.items.data.map(function (row) {
                if (row.NATIVE_RECORD_ID === state.expandedId) {
                    row = updatedContact_1;
                }
                return row;
            });
            var items = state.items;
            var itemsUpdated = __assign({}, items, { data: rowsUpdated });
            return __assign({}, state, { items: itemsUpdated });
        case HIDE_EVENTS:
            var hiddenRow_1 = __assign({}, action.payload, { expanded: false });
            var rowsEdited = state.items.data.map(function (row) {
                if (row.NATIVE_RECORD_ID === hiddenRow_1.NATIVE_RECORD_ID) {
                    row = hiddenRow_1;
                }
                return row;
            });
            var currentItems = state.items;
            var itemsEdited = __assign({}, currentItems, { data: rowsEdited });
            return __assign({}, state, { items: itemsEdited, expandedId: null });
        case UPDATE_COLUMNS:
            return __assign({}, state, { columns: action.payload });
        case SET_DATE_RANGE:
            var tempRangeFilters = void 0;
            if (state.tempPage && state.tempPage.filter) {
                tempRangeFilters = state.tempPage.filter;
            }
            else {
                tempRangeFilters = state.page.filter;
            }
            var updatedRangeFilter = __assign({}, tempRangeFilters, { dateFrom: action.payload.dateFrom, dateTo: action.payload.dateTo });
            var currentTempPage = state.tempPage;
            var updatedTempFilters = __assign({}, currentTempPage, { filter: updatedRangeFilter, pagination: state.page.pagination });
            return __assign({}, state, { tempPage: updatedTempFilters });
        case CLEAR_FILTER:
            var newEditedFilters_1 = [];
            var currentPage = __assign({}, state.page);
            var currentFilterTags_1 = __assign({}, state.filterTags);
            Object.keys(currentFilterTags_1).forEach(function (key) {
                if (currentFilterTags_1[key] !== null) {
                    newEditedFilters_1.push(key);
                }
            });
            return __assign({}, state, { tempPage: currentPage, tempFilterTags: currentFilterTags_1, openedFilter: null, editedFilters: newEditedFilters_1 });
        case UPDATE_TEMP_TAG:
            var updatedTagGroupName = action.payload.source;
            var updatedTagsGroup = action.payload.tags;
            var existingTempTags = state.tempFilterTags;
            var updatedTempTags = __assign({}, existingTempTags, (_a = {}, _a[updatedTagGroupName] = updatedTagsGroup, _a));
            return __assign({}, state, { tempFilterTags: updatedTempTags });
        case ADD_TAG:
            var addedTagGroupName = action.payload.source;
            var tempTags = state.tempFilterTags ? state.tempFilterTags : {};
            var editedTempTagGroup = [];
            var currentTempTagGroup = tempTags && tempTags[addedTagGroupName] ? tempTags[addedTagGroupName] : [];
            if (currentTempTagGroup.filter(function (item) { return item.name === action.payload.name; }).length) {
                editedTempTagGroup = currentTempTagGroup;
            }
            else {
                currentTempTagGroup.push(action.payload);
                editedTempTagGroup = currentTempTagGroup;
            }
            var editedTempTags = __assign({}, tempTags, (_b = {}, _b[addedTagGroupName] = editedTempTagGroup, _b));
            return __assign({}, state, { tempFilterTags: editedTempTags });
        case REMOVE_TAG:
            var temporaryTags = state.tempFilterTags ? state.tempFilterTags : state.filterTags;
            var removedTagGroupName = action.payload.source;
            if (temporaryTags && temporaryTags[removedTagGroupName]) {
                var editedTemporaryTagGroup = temporaryTags[removedTagGroupName].filter(function (tag) { return tag.name !== action.payload.name; });
                var editedTemporaryTags = __assign({}, temporaryTags, (_c = {}, _c[removedTagGroupName] = editedTemporaryTagGroup.length ? editedTemporaryTagGroup : null, _c));
                return __assign({}, state, { tempFilterTags: editedTemporaryTags });
            }
            else {
                return state;
            }
        case SET_FILTER_TAGS:
            var newFilterTags = state.tempFilterTags;
            return __assign({}, state, { filterTags: newFilterTags });
        case GET_FILTER_ITEMS_SUCCESS:
            var filtersItems = action.payload.list;
            var filterItemType = action.payload.filterName;
            var currentEditedFilterItems = state.editedFiltersItems;
            var updatedEditedFilterItems = __assign({}, currentEditedFilterItems, (_d = {}, _d[filterItemType] = filtersItems, _d));
            return __assign({}, state, { editedFiltersItems: updatedEditedFilterItems, openedFilter: filterItemType });
        case SET_FILTER_ITEMS_OPENED:
            return __assign({}, state, { openedFilter: action.payload });
        case SET_FILTERING_BY_ITEM:
            var openedFilterKey = action.payload.filter;
            var currentEditedFilters = void 0;
            var egsistingTempPage = void 0;
            if (state.tempPage && state.tempPage.filter) {
                egsistingTempPage = state.tempPage;
                currentEditedFilters = state.tempPage.filter;
            }
            else {
                egsistingTempPage = state.page;
                currentEditedFilters = state.page.filter;
            }
            var updatedEditedFilters = __assign({}, currentEditedFilters, (_e = {}, _e[openedFilterKey] = action.payload.collection, _e));
            var updatedTempPage = __assign({}, egsistingTempPage, { filter: updatedEditedFilters });
            return __assign({}, state, { tempPage: updatedTempPage });
        case UPDATE_TEMP_PAGE_WITH_ITEMS:
            var lastEditedFiltersItemsNames = void 0;
            var lastOpenedFilter = action.payload;
            var currentEditedFiltersItems = __assign({}, state.editedFiltersItems);
            if (lastOpenedFilter === 'callLengths') {
                lastEditedFiltersItemsNames = currentEditedFiltersItems[lastOpenedFilter].map(function (item) { return item.range; });
            }
            else if (lastOpenedFilter === 'clientPhoneNumbers') {
                lastEditedFiltersItemsNames = currentEditedFiltersItems[lastOpenedFilter].map(function (item) { return item.name; });
            }
            else {
                lastEditedFiltersItemsNames = currentEditedFiltersItems[lastOpenedFilter]
                    .filter(function (el) { return el.isFilter === true; })
                    .map(function (item) { return item.name; });
            }
            var temporaryPage = state.tempPage ? __assign({}, state.tempPage) : __assign({}, state.page);
            var tempPageFilter = temporaryPage.filter;
            var newUpdatedTempFilter = __assign({}, tempPageFilter, (_f = {}, _f[lastOpenedFilter] = lastEditedFiltersItemsNames.length ? lastEditedFiltersItemsNames : null, _f));
            var updatedTemporaryPage = __assign({}, temporaryPage, { filter: newUpdatedTempFilter });
            return __assign({}, state, { tempPage: updatedTemporaryPage });
        case UPDATE_TEMP_EDITED_FILTERS_LIST:
            return __assign({}, state, { tempEditedFilters: action.payload });
        case UPDATE_EDITED_FILTERS_LIST:
            return __assign({}, state, { editedFilters: state.tempEditedFilters });
        case CLEAR_EDITED_FILTERS_LIST:
            return __assign({}, state, { editedFilters: null });
        case TAKE_EDITING_FILTER_SNAPSHOT:
            var editedFiltersShot = state.editedFilters ? state.editedFilters.slice() : [];
            var tempEditedFiltersShot = state.tempEditedFilters ? state.tempEditedFilters.slice() : editedFiltersShot;
            var tempEditedFiltersItemsShot = state.editedFiltersItems ? __assign({}, state.editedFiltersItems) : {};
            var snapshot = {
                tempFilterTags: state.tempFilterTags ? __assign({}, state.tempFilterTags) : __assign({}, state.filterTags),
                editedFiltersItems: tempEditedFiltersItemsShot ? tempEditedFiltersItemsShot : {},
                tempPage: state.tempPage ? __assign({}, state.tempPage) : __assign({}, state.page),
                openedFilter: state.openedFilter,
                tempEditedFilters: tempEditedFiltersItemsShot && tempEditedFiltersItemsShot[state.openedFilter]
                    ? tempEditedFiltersShot
                    : tempEditedFiltersShot
                        ? tempEditedFiltersShot.filter(function (filter) { return filter !== state.openedFilter; })
                        : state.editedFilters.slice(),
                editedFilters: editedFiltersShot
            };
            return __assign({}, state, { editingFilterSnapshot: snapshot });
        case REVERT_EDITED_FILTER_CHANGES:
            var revertSnapshot = __assign({}, state.editingFilterSnapshot);
            var snapshotTempFilterTags = revertSnapshot.tempFilterTags;
            var snapshotEditedFiltersItems = revertSnapshot.editedFiltersItems;
            var snapshotEditedFilters = revertSnapshot.editedFilters;
            var snapshotTempEditedFilters = revertSnapshot.tempEditedFilters;
            var snapshotTempPage = revertSnapshot.tempPage;
            var snapshotCleared = {
                tempFilterTags: __assign({}, state.filterTags),
                editedFiltersItems: __assign({}, state.editedFiltersItems),
                tempPage: __assign({}, state.page),
                openedFilter: null,
                tempEditedFilters: state.editedFilters.slice(),
                editedFilters: state.editedFilters.slice()
            };
            return __assign({}, state, { tempFilterTags: snapshotTempFilterTags ? snapshotTempFilterTags : __assign({}, state.filterTags), editedFiltersItems: snapshotEditedFiltersItems, tempPage: snapshotTempPage, tempEditedFilters: snapshotTempEditedFilters, editedFilters: snapshotEditedFilters, editingFilterSnapshot: snapshotCleared, openedFilter: null });
        case OPEN_TOOLTIP_TAG_GROUP:
            var tagGroupTooltips = state.openedTagGroupTooltips ? state.openedTagGroupTooltips : [];
            var newTagGroupTooltips = tagGroupTooltips.concat([action.payload]);
            return __assign({}, state, { openedTagGroupTooltips: newTagGroupTooltips });
        case CLOSE_TOOLTIP_TAG_GROUP:
            var openedTagGroupTooltips = state.openedTagGroupTooltips;
            var filteredTagGroupTooltips = openedTagGroupTooltips.filter(function (el) { return el !== action.payload; });
            return __assign({}, state, { openedTagGroupTooltips: filteredTagGroupTooltips });
        case CLEAR_TOOLTIP_TAG_GROUP:
            return __assign({}, state, { openedTagGroupTooltips: [] });
        case SAVE_CALL_RANGE_FILTER_FORM:
            return __assign({}, state, { callLengthForm: action.payload });
        case UPDATE_TEMP_FILTER_MAXDATA:
            var beforeEditDataTempPage = state.tempPage ? state.tempPage : state.page;
            var beforeTempPageFilter = beforeEditDataTempPage.filter;
            var correctedTempPageFilter = __assign({}, beforeTempPageFilter, { dateTo: action.payload });
            var correctedTempPage = __assign({}, beforeEditDataTempPage, { filter: correctedTempPageFilter });
            return __assign({}, state, { tempPage: correctedTempPage });
        case RESET_STATE:
            return __assign({}, initialState);
        case UPDATE_EXPANDED_LIST:
            return __assign({}, state, { expandedList: action.payload });
        case SET_CALL_FINISH_TYPE_FILTER:
            var beforeFinishTypeTempPage = __assign({}, state.tempPage);
            var beforeFinishTypeTempPageFilter = beforeFinishTypeTempPage.filter;
            var finishTypeFilter = __assign({}, beforeFinishTypeTempPageFilter, { callFinishType: action.payload });
            var finishTypeTempPage = __assign({}, beforeFinishTypeTempPage, { filter: finishTypeFilter });
            return __assign({}, state, { tempPage: finishTypeTempPage });
        case REMOVE_CALL_FINISH_TYPE_FILTER:
            var beforeDeletingFinishTypeTempPage = __assign({}, state.tempPage);
            var beforeDeletingFinishTypeTempPageFilter = beforeDeletingFinishTypeTempPage.filter;
            delete beforeDeletingFinishTypeTempPageFilter[action.payload];
            var deletedFinishTypeFilter = __assign({}, beforeDeletingFinishTypeTempPageFilter);
            var deletedFinishTypeTempPage = __assign({}, beforeDeletingFinishTypeTempPage, { filter: deletedFinishTypeFilter });
            return __assign({}, state, { tempPage: deletedFinishTypeTempPage });
        case TAKE_CALL_FINISH_TYPE_SNAPSHOT:
            var snapshotedTempPage = __assign({}, state.tempPage);
            var snapshotedCallFinishType = snapshotedTempPage.filter.callFinishType;
            if (snapshotedCallFinishType) {
                return __assign({}, state, { callFinishTypeSnapshot: snapshotedCallFinishType });
            }
            else {
                return state;
            }
        case REVERT_CALL_FINISH_TYPE_SNAPSHOT:
            var currentCallFinisTypeSnapshot = state.callFinishTypeSnapshot;
            var currentTempPageToRevert = __assign({}, state.tempPage);
            var currentTempPageFilterToRevert = currentTempPageToRevert.filter;
            if (currentCallFinisTypeSnapshot) {
                var revertedTempPageFilter = __assign({}, currentTempPageFilterToRevert, { callFinishType: currentCallFinisTypeSnapshot });
                var revertedTempPage = __assign({}, currentTempPageToRevert, { filter: revertedTempPageFilter });
                var revertModifiedState = __assign({}, state, { tempPage: revertedTempPage });
                delete revertModifiedState.callFinishTypeSnapshot;
                return revertModifiedState;
            }
            else {
                var stateToRevertCallFinishType = __assign({}, state);
                delete stateToRevertCallFinishType.tempPage.filter.callFinishType;
                return stateToRevertCallFinishType;
            }
        case TOGGLE_CONTACTS_TABLE:
            var tableOptionPage = state.tempPage ? __assign({}, state.tempPage) : __assign({}, state.page);
            var tableOptionPagePagination = __assign({}, tableOptionPage.pagination, { offset: 0 });
            var correctedOptionPage = __assign({}, tableOptionPage, { pagination: tableOptionPagePagination });
            return __assign({}, state, { eventsOption: action.payload, tempPage: correctedOptionPage });
        case EDIT_SEARCH_PHRASE_ACTION:
            var previousTempPage = state.tempPage ? __assign({}, state.tempPage) : __assign({}, state.page);
            var previousTempPageFilter = __assign({}, previousTempPage.filter);
            var searchPhraseFilter = __assign({}, previousTempPageFilter, { fullTextSearchPhrase: action.payload });
            var searchPhraseTypeTempPage = __assign({}, previousTempPage, { filter: searchPhraseFilter });
            return __assign({}, state, { tempPage: searchPhraseTypeTempPage });
        case SET_MASSIVE_OPTION_ACTION:
            return __assign({}, state, { massiveActions: action.payload });
        case CLEAR_PAGE_OFFSET_ACTION:
            var previousOffsetPage = state.tempPage ? __assign({}, state.tempPage) : __assign({}, state.page);
            var newOffsetPagination = __assign({}, previousOffsetPage.pagination, { offset: action.payload });
            var newOffsetTempPage = __assign({}, previousOffsetPage, { pagination: newOffsetPagination });
            return __assign({}, state, { tempPage: newOffsetTempPage });
        case SET_PAGE_OFFSET_ACTION:
            var existingOffsetPage = state.tempPage ? __assign({}, state.tempPage) : __assign({}, state.page);
            var contactsOffsetPagination = __assign({}, existingOffsetPage.pagination, { offset: action.payload });
            var improvedOffsetTempPage = __assign({}, existingOffsetPage, { pagination: contactsOffsetPagination });
            return __assign({}, state, { tempPage: improvedOffsetTempPage });
        case TOGGLE_TAG_EDITOR_ACTION:
            return __assign({}, state, { tagEditorOpened: action.payload });
        default:
            return state;
    }
}
var getContactsRows = function (contactState) { return contactState.items.data; };
var ɵ0 = getContactsRows;
var getContactsCols = function (contactState) { return contactState.columns; };
var ɵ1 = getContactsCols;
var getRawContactsColumns = function (contactState) { return contactState.rawColumns; };
var ɵ2 = getRawContactsColumns;
var getContactsTotal = function (contactState) { return contactState.items.total; };
var ɵ3 = getContactsTotal;
var getContactsPage = function (contactState) { return contactState.page; };
var ɵ4 = getContactsPage;
var getTempPage = function (contactState) { return contactState.tempPage; };
var ɵ5 = getTempPage;
var getCampaigns = function (contactState) { return contactState.campaigns; };
var ɵ6 = getCampaigns;
var getTags = function (contactState) { return contactState.filterTags; };
var ɵ7 = getTags;
var getTempTags = function (contactState) { return contactState.tempFilterTags; };
var ɵ8 = getTempTags;
var getEditedFilters = function (contactState) { return contactState.editedFilters; };
var ɵ9 = getEditedFilters;
var getTempEditedFilters = function (contactState) { return contactState.tempEditedFilters; };
var ɵ10 = getTempEditedFilters;
var getEditedFilterItems = function (contactState) { return contactState.editedFiltersItems; };
var ɵ11 = getEditedFilterItems;
var getOpenedFilterItem = function (contactState) { return contactState.openedFilter; };
var ɵ12 = getOpenedFilterItem;
var getExpandedList = function (contactState) { return contactState.expandedList; };
var ɵ13 = getExpandedList;
var getOpenedTagGroupTooltips = function (contactState) { return contactState.openedTagGroupTooltips; };
var ɵ14 = getOpenedTagGroupTooltips;
var getCallLengthForm = function (contactState) { return contactState.callLengthForm; };
var ɵ15 = getCallLengthForm;
var getSnapshot = function (contactState) { return contactState.editingFilterSnapshot; };
var ɵ16 = getSnapshot;
var getEventsOption = function (contactState) { return contactState.eventsOption; };
var ɵ17 = getEventsOption;
var getMassiveAction = function (contactState) { return contactState.massiveActions; };
var ɵ18 = getMassiveAction;
var getExcludedContacts = function (contactState) { return contactState.excludedContacts; };
var ɵ19 = getExcludedContacts;
var getTagEditorOpened = function (contactState) { return contactState.tagEditorOpened; };
var ɵ20 = getTagEditorOpened;
var getExpandedId = function (contactState) { return contactState.expandedId; };
var ɵ21 = getExpandedId;
export var getMainContactsSelector = function (state) { return state.contacts; };
export var getContactsRowsSelector = createSelector(getMainContactsSelector, getContactsRows);
export var getContactsColsSelector = createSelector(getMainContactsSelector, getContactsCols);
export var getRawContactsColumnsSelector = createSelector(getMainContactsSelector, getRawContactsColumns);
export var getContactsTotalSelector = createSelector(getMainContactsSelector, getContactsTotal);
export var getContactsPageSelector = createSelector(getMainContactsSelector, getContactsPage);
export var getTempPageSelector = createSelector(getMainContactsSelector, getTempPage);
export var getCampaignsSelector = createSelector(getMainContactsSelector, getCampaigns);
export var getTagsSelector = createSelector(getMainContactsSelector, getTags);
export var getTempTagsSelector = createSelector(getMainContactsSelector, getTempTags);
export var getEditedFiltersSelector = createSelector(getMainContactsSelector, getEditedFilters);
export var getTempEditedFiltersSelector = createSelector(getMainContactsSelector, getTempEditedFilters);
export var getEditedFilterItemsSelector = createSelector(getMainContactsSelector, getEditedFilterItems);
export var getOpenedFilterItemSelector = createSelector(getMainContactsSelector, getOpenedFilterItem);
export var getExpandedListSelector = createSelector(getMainContactsSelector, getExpandedList);
export var getOpenedTagGroupTooltipsSelector = createSelector(getMainContactsSelector, getOpenedTagGroupTooltips);
export var getCallLengthFormSelector = createSelector(getMainContactsSelector, getCallLengthForm);
export var getSnapshotSelector = createSelector(getMainContactsSelector, getSnapshot);
export var getEventsOptionSelector = createSelector(getMainContactsSelector, getEventsOption);
export var getMassiveActionSelector = createSelector(getMainContactsSelector, getMassiveAction);
export var getExcludedContactsSelector = createSelector(getMainContactsSelector, getExcludedContacts);
export var getTagEditorOpenedSelector = createSelector(getMainContactsSelector, getTagEditorOpened);
export var getExpandedIdSelector = createSelector(getMainContactsSelector, getExpandedId);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21 };
